<footer class="mt-4">
  <div class="footer-content">
    <div class="footer-links">
      <lib-menu-bar [mode]="'footer'"></lib-menu-bar>
    </div>

    <div class="version-container">
      <div class="version-info" *ngIf="versionData">
        Version:&nbsp;{{ versionData.version }}
      </div>
    </div>
  </div>
</footer>
